import DemoMessage from './demo-message';

export default DemoMessage;
